import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import { useTranslation } from 'react-i18next';

const DefaultLanguageField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const { t: tForm } = useTranslation('form');
	const defaultLanguageName = tForm(restaurantForFullInfo?.languageName || '');

	return <FullInfoField label="defaultLanguageLabel" value={defaultLanguageName} />;
};

export default DefaultLanguageField;
